<template>
   <div class="col-sm-12 col-md-8">
      <div class="card">
         <div class="card-body">
            <h4 class="card-title mb-4">Detalles del cliente</h4>
            <load-spinner v-if="loading"></load-spinner>
         
            <div v-else class="row">
               <div class="col-sm-12">
                  <div class="row">
                     <div class="col-4">
                        <p class="text-muted mb-0"><span class="title">Nombre cliente:</span> {{ details.name }}</p>
                     </div>
                     <div class="col-4">
                        <p class="text-muted mb-0"><span class="title">Teléfono:</span> {{ details.phone }}</p>
                     </div>
                     <div class="col-4">
                        <p class="text-muted mb-0"><span class="title">Mail:</span> {{ details.mail }}</p>
                     </div>
                     <hr class="mx-2">
                  </div>
                  <div class="row mt-1">
                     <div class="col-4">
                        <p class="text-muted mb-0"><span class="title">Nombre PV:</span> {{ details.pv }}</p>
                     </div>
                     <div class="col-4">
                        <p class="text-muted mb-0"><span class="title">Código:</span> {{ details.code }}</p>
                     </div>
                     <div class="col-4">
                        <p class="text-muted mb-0"><span class="title">Mail:</span> {{ details.mailPV }}</p>
                     </div>
                  </div>
                  <div class="row mt-3">
                     <div class="col-4">
                        <p class="text-muted mb-0"><span class="title">Categoría:</span> {{ details.category }}</p>
                     </div>
                     <div class="col-4">
                        <p class="text-muted mb-0"><span class="title">Bloqueado:</span> {{ details.blocked }}</p>
                     </div>
                     <div class="col-4">
                        <p class="text-muted mb-0"><span class="title">Teléfono:</span> {{ details.phonePV }}</p>
                     </div>
                  </div>
                  <div class="row mt-3">
                     <div class="col-8">
                        <p class="text-muted mb-0"><span class="title">Dirección:</span> {{ details.address }}</p>
                     </div>
                     <div class="col-4">
                        <b-button v-if="!correccionEnviada" v-b-modal.modal-center variant="btn btn-danger btn-sm">Enviar corrección</b-button>
                        <div v-else class="alert alert-dismissible alert-success"><button type="button" aria-label="Close" class="close">×</button>Corrección enviada.</div>
                        <b-modal ref="modal-center" id="modal-center" centered title="Enviar Corrección" title-class="font-18" hide-footer>
                           <div class="modal-content">
                              <div class="modal-body">
                                 <textarea v-model="correccion" maxlength="225" rows="6" placeholder="Escriba la correción a enviar." class="form-control"></textarea>
                                 <div class="text-center mt-1">
                                    <p class="badge position-absolute" :class="{ 'badge-success': correccion.length !== 225, 'badge-danger': correccion.length === 225 }">
                                       {{ correccion.length }} /
                                       225
                                    </p>
                                 </div>
                              </div>
                              <div class="modal-footer">
                                 <button @click="enviarCorreccion" type="button" class="btn btn-danger" data-dismiss="modal-center" :disabled="correccion.length == 0">Enviar <b-spinner v-if="loadingEnviar" small></b-spinner></button>
                              </div>
                           </div>
                        </b-modal>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>      
   </div>
</template>

<script>
   import LoadSpinner from '@/components/widgets/LoadSpinner'
   import axios from 'axios'

   export default {
      name: 'Details-Widget',
      data() {
         return {
            loading: true,
            details: { },
            correccion: '',
            correccionEnviada: false,
            loadingEnviar: false
         }
      },
      methods: {
         async enviarCorreccion () {
            this.loadingEnviar = true
            let params = "json="+JSON.stringify({ 'detalles': this.details, 'correccion': this.correccion, 'repre': this.$store.state.user.fullname })

            await axios({url: 'https://portal.asein.es/api-v2/widget-correccion', data: params, method: 'POST' })
            .then(resp => {
               if (resp.data) {
                  this.correccion = ''
                  this.correccionEnviada = true
                  this.loadingEnviar = false
               }
            })
            .catch(err => {
               console.log(err)
            })
            this.$refs['modal-center'].hide()
         }
      },
      components: { LoadSpinner },
      async mounted () {
         let codcli = this.$route.params.codcli
         let coddep = this.$route.params.coddep
         let zona = this.$store.state.user.selectedZone

         let params = "json="+JSON.stringify({ 'codcli': codcli, 'coddep': coddep, 'repre': zona })

         await axios({url: 'https://portal.asein.es/api-v2/widget-detalles', data: params, method: 'POST' })
         .then(resp => {
            this.details = resp.data
            this.loading = false
         })
         .catch(err => {
            console.log(err)
         })
      }
   }
</script>

<style scoped>
   .title {
      color: #495057;
      font-weight: 500;
   }
   hr {
      width: 100%;
   }
</style>